import { Button, Modal } from '@hakimo-ui/shared/ui-base';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  tenantName: string;
}

export function DeleteTenantModal({
  open,
  onClose,
  onConfirm,
  isDeleting,
  tenantName,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Confirm Delete"
      footer={
        <>
          <Button
            variant="error"
            onClick={onConfirm}
            loading={isDeleting}
            disabled={isDeleting}
            autoFocus
          >
            Delete
          </Button>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
        </>
      }
      closable={!isDeleting}
    >
      <div className="max-w-xl p-6">
        <p className="text-onlight-text-1 dark:text-ondark-text-1">
          Are you sure you want to delete <strong>{tenantName}</strong>? This
          will deactivate the tenant and it will no longer be accessible.
        </p>
      </div>
    </Modal>
  );
}

export default DeleteTenantModal;
